import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { DatePicker, WithScrollableContainerRef } from '@adsk/bim360-matrix-react-components';
import { toUtcLongDate } from '../../../../../../../utils/date-helpers';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';

const DatePickerWithContainer = WithScrollableContainerRef(DatePicker, 'IssuePreview__content');

class DueDateToInlineEdit extends PureComponent {

  render() {
    const { issue, className, styleType } = this.props;
    return (
      <IssueFieldInlineEdit
        issue={issue}
        attributeName={ISSUE_ATTRIBUTE_NAMES.DUE_DATE}
        label={T.translate('new.dueDate')}
        getDisplayValue={(currentValue) => currentValue ? toUtcLongDate(currentValue) : ''}
        placeholder={T.translate('dueDate.unspecified')}
        className={className}
        data-testid="DueDateInlineEdit"
        styleType={styleType}
      >
        {(currentValue, closeEditMode, updateIssue) => <DatePickerWithContainer
          openOnMount
          disablePastDates
          placeholder={T.translate('dueDate.unspecified')}
          date={currentValue ? new Date(currentValue) : null}
          onClickOutside={closeEditMode}
          onChange={(newMomentValue) => {
            updateIssue(newMomentValue);
          }}
        />}
      </IssueFieldInlineEdit>
    );
  }
}

DueDateToInlineEdit.displayName = 'DueDateToInlineEdit';

DueDateToInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
};

export default DueDateToInlineEdit;
